import { render, staticRenderFns } from "./ngo-breadcrumbs.vue?vue&type=template&id=317d961d&scoped=true&"
import script from "./ngo-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ngo-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./ngo-breadcrumbs.vue?vue&type=style&index=0&id=317d961d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317d961d",
  null
  
)

export default component.exports